import { Stack } from "@mui/material";
import type { FC } from "react";
import type { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { maturityFormatter } from "web_myplann/Portfolio/Helpers/maturityFormatter";
import { getPortfolioFrequencyValue } from "web_myplann/Portfolio/Helpers/portfolioDetailFormatters";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";
import { EMPTY_DETAIL_FIELD } from "web_myplann/Utils/constants";

const PageResources = Resources.PortfolioDetail;

type Props = {
	originalObligationAmount: number | null | undefined;
	maturityLengthMonths: number | null | undefined;
	interestRate: number | null | undefined;
	installment: number | null | undefined;
	paymentFrequency: ClientPortfolioPaymentFrequencyEnum | null | undefined;
	currencySign: string;
};

export const LoanParameters: FC<Props> = ({
	originalObligationAmount,
	maturityLengthMonths,
	interestRate,
	installment,
	paymentFrequency,
	currencySign,
}) => {
	const { t } = useResource();

	const interestRateValue = interestRate
		? `${interestRate} % p.a.`
		: EMPTY_DETAIL_FIELD;

	const installmentValue = getPortfolioFrequencyValue(
		installment,
		currencySign,
		paymentFrequency ?? null,
		t,
	);

	return (
		<Stack>
			<DetailRow
				label={t(PageResources.Loan.amount)}
				value={moneyFormatter(originalObligationAmount, currencySign)}
			/>
			<DetailRow
				label={t(PageResources.Loan.matury)}
				value={maturityFormatter(maturityLengthMonths ?? 0, t)}
			/>
			<DetailRow
				label={t(PageResources.Loan.interestRate)}
				value={interestRateValue}
			/>
			<DetailRow
				label={t(PageResources.Loan.installment)}
				value={installmentValue}
			/>
		</Stack>
	);
};
